import { ApolloProvider } from "@apollo/client";
import "native-injects";
import React from "react";
// import * as ReactDOMClient from "react-dom/client";
import ReactDOM from "react-dom";
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";
// import reportWebVitals from "./reportWebVitals";
// eslint-disable-next-line import/no-extraneous-dependencies
import { History } from "@remix-run/router";
import client from "./api";
import { BrowserHistory } from "./components/dirty-tracker/DirtyTracker";
import { RoutingProvider } from "./contexts/Routing";
import App from "./pages/app/App";
import "./theme/index.scss";

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
// eslint-disable-next-line no-undef, camelcase
__webpack_nonce__ = process.env.SERVER_NONCE;

/* eslint-disable @typescript-eslint/no-namespace */
declare global {
    interface Window {
        NONCE: string,
        FOQAL_VERSION_NUMBER: string
    }
}
/* eslint-enable @typescript-eslint/no-namespace */

const rootElement = document.getElementById("root") as HTMLElement;

const body = (
    <React.StrictMode>
        <ApolloProvider client={client}>
            <HistoryRouter history={BrowserHistory as unknown as History}>
                <RoutingProvider>
                    <App />
                </RoutingProvider>
            </HistoryRouter>
        </ApolloProvider>
    </React.StrictMode>
);

// const root = ReactDOMClient.createRoot(rootElement);

// root.render(
//     body
// );

ReactDOM.render(body, rootElement);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(data => {
//     console.log(data);
// });
